export default "/_next/static/images/adam-storm-60d375140b39bfc1f66374e0d4f1c47e.png";